/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportingMelcoModelsCustomWarning
 */
export interface ReportingMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function ReportingMelcoModelsCustomWarningFromJSON(json: any): ReportingMelcoModelsCustomWarning {
    return ReportingMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function ReportingMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ReportingMelcoModelsCustomWarningToJSON(value?: ReportingMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


